import { FormattedMessage, useIntl } from "react-intl";

import FeatureGates from "@atlassian/feature-gate-js-client";
import UFOSegment from "@atlassian/wac-ufo-segment";

import { DEFAULT_VALUES } from "@/libraries/web-framework";
import {
    Adg4BannerAlert,
    BannerProps
} from "@/patterns/adg4/banner-alert/banner-alert";

export const Team24BannerAlert = () => {
    const intl = useIntl();

    const bannerBeforeEvent: BannerProps = {
        identifier: "HomePageTemplateV2.team-24-banner-alert-before-event",
        text: (
            <FormattedMessage
                id="HomePageTemplateV2.banner-alert.text.team-24-banner-alert.beforeEvent"
                defaultMessage="<strong>Don't miss a single conference keynote, product drop, or our amazing speaker lineup.</strong>"
                values={DEFAULT_VALUES}
            />
        ),
        linkText: intl.formatMessage({
            id: "HomePageTemplateV2.linkText.team-24-banner-alert.beforeEvent",
            defaultMessage: "Watch from anywhere"
        }),
        linkUrl:
            "https://events.atlassian.com/team/livestream?ref=Team_24&utm_source=marketing&utm_campaign=acquisition&utm_content=wac_homepage_butterbar&utm_medium=banner-alert-before-event",
        productKey: "home",
        dataEventProps: {
            "data-product-key": "home",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": intl.formatMessage({
                id: "HomePageTemplateV2.dataLabel.team-24-banner-alert.beforeEvent",
                defaultMessage: "Watch from anywhere"
            }),
            "data-label-english": "Watch from anywhere"
        }
    };

    const bannerDay1: BannerProps = {
        identifier: "HomePageTemplateV2.team-24-banner-alert-day1",
        text: (
            <FormattedMessage
                id="HomePageTemplateV2.banner-alert.text.team-24-banner-alert.day1"
                defaultMessage="<strong>The new era of teamwork is here. Catch the Keynote from Atlassian's Co-Founders and Co-CEOs.</strong>"
                values={DEFAULT_VALUES}
            />
        ),
        linkText: intl.formatMessage({
            id: "HomePageTemplateV2.linkText.team-24-banner-alert.day1",
            defaultMessage: "Watch now"
        }),
        linkUrl:
            "https://events.atlassian.com/team/livestream?ref=Team_24&utm_source=marketing&utm_campaign=acquisition&utm_content=wac_homepage_butterbar&utm_medium=banner-alert-day_1",
        productKey: "home",
        dataEventProps: {
            "data-product-key": "home",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": intl.formatMessage({
                id: "HomePageTemplateV2.dataLabel.team-24-banner-alert.day1",
                defaultMessage: "Watch now"
            }),
            "data-label-english": "Watch now"
        }
    };

    const bannerSpork: BannerProps = {
        identifier: "HomePageTemplateV2.team-24-banner-alert-spork",
        text: (
            <FormattedMessage
                id="HomePageTemplateV2.banner-alert.text.team-24-banner-alert.spork"
                defaultMessage="<strong>Introducing a new evolution of Jira: a flexible and powerful tool for all teams.</strong>"
                values={DEFAULT_VALUES}
            />
        ),
        linkText: intl.formatMessage({
            id: "HomePageTemplateV2.linkText.team-24-banner-alert.spork",
            defaultMessage: "Learn more"
        }),
        linkUrl:
            "https://events.atlassian.com/team/livestream?ref=Team_24&utm_source=marketing&utm_campaign=acquisition&utm_content=wac_homepage_butterbar&utm_medium=banner-alert-announcement_1",
        productKey: "home",
        dataEventProps: {
            "data-product-key": "home",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": intl.formatMessage({
                id: "HomePageTemplateV2.dataLabel.team-24-banner-alert.spork",
                defaultMessage: "Learn more"
            }),
            "data-label-english": "Learn more"
        }
    };

    const bannerAi: BannerProps = {
        identifier: "HomePageTemplateV2.team-24-banner-alert-ai",
        text: (
            <FormattedMessage
                id="HomePageTemplateV2.banner-alert.text.team-24-banner-alert.ai"
                defaultMessage="<strong>Keynote:</strong> <span>See how to plan for the impact of AI on jobs, workforce productivity, and brand trust.</span>"
                values={DEFAULT_VALUES}
            />
        ),
        linkText: intl.formatMessage({
            id: "HomePageTemplateV2.linkText.team-24-banner-alert.ai",
            defaultMessage: "Watch now"
        }),
        linkUrl:
            "https://events.atlassian.com/team/livestream?ref=Team_24&utm_source=marketing&utm_campaign=acquisition&utm_content=wac_homepage_butterbar&utm_medium=banner-alert-annoucement_2",
        productKey: "home",
        dataEventProps: {
            "data-product-key": "home",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": intl.formatMessage({
                id: "HomePageTemplateV2.dataLabel.team-24-banner-alert.ai",
                defaultMessage: "Watch now"
            }),
            "data-label-english": "Watch now"
        }
    };

    const bannerDay2: BannerProps = {
        identifier: "HomePageTemplateV2.team-24-banner-alert.day2",
        text: (
            <FormattedMessage
                id="HomePageTemplateV2.banner-alert.text.team-24-banner-alert.day2"
                defaultMessage="<strong>Learn how to fuel growth and spark innovation in an unpredictable landscape.</strong>"
                values={DEFAULT_VALUES}
            />
        ),
        linkText: intl.formatMessage({
            id: "HomePageTemplateV2.linkText.team-24-banner-alert.day2",
            defaultMessage: "Watch now"
        }),
        linkUrl:
            "https://events.atlassian.com/team/livestream?ref=Team_24&utm_source=marketing&utm_campaign=acquisition&utm_content=wac_homepage_butterbar&utm_medium=banner-alert-day_2",
        productKey: "home",
        dataEventProps: {
            "data-product-key": "home",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": intl.formatMessage({
                id: "HomePageTemplateV2.dataLabel.team-24-banner-alert.day2",
                defaultMessage: "Watch now"
            }),
            "data-label-english": "Watch now"
        }
    };

    const bannerAfterEvent: BannerProps = {
        identifier: "HomePageTemplateV2.team-24-banner-alert.afterEvent",
        text: (
            <FormattedMessage
                id="HomePageTemplateV2.banner-alert.text.team-24-banner-alert.afterEvent"
                defaultMessage="<strong>Catch the keynote announcements, curated session playlists, and exclusive content for free.</strong>"
                values={DEFAULT_VALUES}
            />
        ),
        linkText: intl.formatMessage({
            id: "HomePageTemplateV2.linkText.team-24-banner-alert.afterEvent",
            defaultMessage: "Watch now"
        }),
        linkUrl:
            "https://events.atlassian.com/team/livestream?ref=Team_24&utm_source=marketing&utm_campaign=acquisition&utm_content=wac_homepage_butterbar&utm_medium=banner-alert-after_event",
        productKey: "home",
        dataEventProps: {
            "data-product-key": "home",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": intl.formatMessage({
                id: "HomePageTemplateV2.dataLabel.team-24-banner-alert.afterEvent",
                defaultMessage: "Watch now"
            }),
            "data-label-english": "Watch now"
        }
    };

    const bannerGeneral: BannerProps = {
        identifier: "HomePageTemplateV2.team-24-banner-alert.general",
        text: (
            <FormattedMessage
                id="HomePageTemplateV2.banner-alert.text.team-24-banner-alert.general"
                defaultMessage="<strong>Catch Team '24 livestream May 1 & 2 then exclusive on-demand sessions starting May 4.</strong>"
                values={DEFAULT_VALUES}
            />
        ),
        linkText: intl.formatMessage({
            id: "HomePageTemplateV2.linkText.team-24-banner-alert.general",
            defaultMessage: "Watch live"
        }),
        linkUrl:
            "https://events.atlassian.com/team/livestream?ref=Team_24&utm_source=marketing&utm_campaign=acquisition&utm_content=wac_homepage_butterbar&utm_medium=banner-alert-general",
        productKey: "home",
        dataEventProps: {
            "data-product-key": "home",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": intl.formatMessage({
                id: "HomePageTemplateV2.dataLabel.team-24-banner-alert.general",
                defaultMessage: "Watch live"
            }),
            "data-label-english": "Watch live"
        }
    };

    switch (true) {
        case FeatureGates.checkGate("wac-team24-banner-alert-before-event"):
            return (
                <UFOSegment name="homepage-v2-bannerAlert">
                    <Adg4BannerAlert {...bannerBeforeEvent} />
                </UFOSegment>
            );
        case FeatureGates.checkGate("wac-team24-banner-alert-day1"):
            return (
                <UFOSegment name="homepage-v2-bannerAlert">
                    <Adg4BannerAlert {...bannerDay1} />
                </UFOSegment>
            );
        case FeatureGates.checkGate("wac-team24-banner-alert-spork"):
            return (
                <UFOSegment name="homepage-v2-bannerAlert">
                    <Adg4BannerAlert {...bannerSpork} />
                </UFOSegment>
            );
        case FeatureGates.checkGate("wac-team24-banner-alert-ai"):
            return (
                <UFOSegment name="homepage-v2-bannerAlert">
                    <Adg4BannerAlert {...bannerAi} />
                </UFOSegment>
            );
        case FeatureGates.checkGate("wac-team24-banner-alert-day2"):
            return (
                <UFOSegment name="homepage-v2-bannerAlert">
                    <Adg4BannerAlert {...bannerDay2} />
                </UFOSegment>
            );
        case FeatureGates.checkGate("wac-team24-banner-alert-after-event"):
            return (
                <UFOSegment name="homepage-v2-bannerAlert">
                    <Adg4BannerAlert {...bannerAfterEvent} />
                </UFOSegment>
            );
        case FeatureGates.checkGate("wac-team24-banner-alert-general"):
            return (
                <UFOSegment name="homepage-v2-bannerAlert">
                    <Adg4BannerAlert {...bannerGeneral} />
                </UFOSegment>
            );
        default:
            return null;
    }
};
